module.exports = __webpack_public_path__ + "img/Spinner-1s-200px.130b01a.gif";